<template>
  <div>
    <p>
      {{payment.sku | getShortBillingServiceId}} rewards
    </p>

    <ul
      v-if="hasRewards"
      class="rewards"
    >
      <li
        v-for="reward in payment.rewards"
        :key="reward.id"
      >
        {{reward.protoId | getProtoAlias}}
        {{reward.amount}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PlayerOfferPayment',

  props: {
    payment: {
      type: Object,
    },
  },

  computed: {
    hasRewards() {
      if(!('rewards' in this.payment)) {
        return false;
      }
      return this.payment.rewards.length > 0;
    },
  },
};
</script>

<style scoped>
  .rewards {
    list-style-type: none;
    padding-left: 0;
  }
</style>
